module.exports = __webpack_public_path__ + "static/media/keto-extreme-1.da4a1e59.png";